document.addEventListener('DOMContentLoaded', () => {
  
  const gallerySections = document.querySelectorAll('.gallery-with-products, .before-after-slider');

  if (gallerySections) {
    gallerySections.forEach(section => {
      const uniqueId = section.dataset.id;

      const pillsContainer = section.querySelector(`div.flex-wrap`);
      const galleryItems = section.querySelectorAll(`.gallery-item-${uniqueId}`);

      if (!pillsContainer || galleryItems.length === 0) return;

      const firstItem = galleryItems[0];
      const firstVideo = firstItem.querySelector('video');
      if (firstVideo) firstVideo.play().catch(() => {});

      pillsContainer.addEventListener('click', (e) => {
        const pill = e.target.closest(`.pill-btn-${uniqueId}`);
        if (!pill) return;

        const pillId = pill.dataset.pillId;

        pillsContainer.querySelectorAll(`.pill-btn-${uniqueId}`).forEach(p => {
          p.classList.remove('selected');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('selected');
        pill.setAttribute('aria-pressed', 'true');

        galleryItems.forEach(item => {
          const itemId = item.dataset.itemId;
          const video = item.querySelector('video');

          if (itemId === pillId) {
            item.classList.remove('hidden');
            if (video) video.play().catch(() => {});
          } else {
            item.classList.add('hidden');
            if (video) video.pause();
          }
        });
      });
    });
  }
});